import {SpotlightAction, SpotlightProvider} from "@mantine/spotlight";
import {ReactElement} from "react";
import {CirclePlus, CloudDownload} from "tabler-icons-react";
import {useSmartTriggerRepository} from "../../context/smartTriggerRepositoryProvider";

export type SmartTriggerProcessorSpotlightProps = {
    children: ReactElement,
    previousProcessorId: string,
    nextProcessorId: string,
    onTrigger: (actionPayload: SmartTriggerProcessorSpotLightPayload) => void,
    type: SpotLightType
}

export type SmartTriggerProcessorSpotLightPayload = {
    action: "new" | "pull",
    payload: {
        processorRepositoryId?: string
    }
}

export type SpotLightType = 'PROCESSOR'

export function SmartTriggerProcessorSpotlight({
                                                   children,
                                                   nextProcessorId,
                                                   previousProcessorId,
                                                   type,
                                                   onTrigger
                                               }: SmartTriggerProcessorSpotlightProps) {

    const smartTriggerRepository = useSmartTriggerRepository();
    const actions: SpotlightAction[] = [
        {
            title: 'Create a Brand New Processor',
            description: 'Generate a brand new processor tailored to your needs.',
            onTrigger: () => onTrigger({
                action: "new",
                payload: {}
            }),
            group: " ",
            icon: <CirclePlus size={40}/>,
        }
    ];

    smartTriggerRepository.processors.map(processor => {
        return ({
            title: processor.name,
            description: processor.description,
            onTrigger: () => onTrigger({
                action: "pull",
                payload: {
                    processorRepositoryId: processor.id
                }
            }),
            group: "Download From SalesCode Repository",
            icon: <CloudDownload/>,
        })
    }).forEach(action => actions.push(action))


    return (
        <SpotlightProvider
            actions={actions}
            searchPlaceholder="Create or Download processor from SalesCode repository"
            shortcut="mod + shift + 1"
            highlightQuery
            highlightColor={"teal"}
            nothingFoundMessage="Nothing found..."
        >
            {children}
        </SpotlightProvider>
    )
}
